import styled from "styled-components";
import Button from "components/Button";
import COLORS from "shared/constants/colors";

export const Container = styled.div`
  margin: 20px;
`;

export const Header = styled.div`
  border-bottom: 1px solid #676a6c;
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  padding-bottom: 10px;
  justify-content: space-between;
`;

export const Title = styled.h1`
  margin: 0;
`;

export const Filter = styled.div`
  display: flex;
  gap: 20px;
  .MuiFormControl-root {
    width: 100px;
  }

  button {
    background-color: #000000;
    color: #ffffff;
    box-shadow: none;
    :hover {
      background-color: #000000;
      color: #ffffff;
      box-shadow: none;
    }
  }
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

export const OrderWrapper = styled.div`
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  display: grid;
  grid-gap: 20px;
`;

export const SampleOrder = styled.p`
  margin: 0;
  position: absolute;
  top: 5px;
  left: 5px;
  color: red;
  font-weight: bold;
`;

export const OrderCard = styled.div`
  background: ${COLORS.WHITE};
  box-shadow: 5px 5px 10px #d9d9d9, -5px -5px 10px ${COLORS.WHITE};
  padding: 30px 15px 15px 15px;
  border-radius: 4px;
  position: relative;
  transition: all ease-out 0.25s;
  border: 1px solid transparent;
  max-width: 300px;
  :hover {
    cursor: pointer;
    box-shadow: 0px 10px 10px #d9d9d9, -5px -5px 10px #ffffff;
    background: #f2f2f2;
  }
`;

export const Status = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  font-weight: bold;
  background: ${(props) =>
    props?.approved || props?.processed || props?.shipped
      ? "green"
      : props?.declined
      ? "red"
      : "orange"};
  color: white;
  padding: 5px;
`;

export const Row = styled.div`
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
`;

export const RowHeader = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  font-weight: bold;
`;

export const SubRow = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;

  .src {
    background-image: url(https://developer.android.com/reference/android/images/graphics/composite_CLEAR.png?hl=vi);
    display: flex;
    background-size: 50%;
  }

  img {
    width: 150px;
  }
`;

export const RowFooter = styled.div`
  display: flex;
  gap: 10px;
  margin: 20px 0;
  justify-content: flex-end;

  button {
    color: white;
    background-color: black;

    :hover {
      color: white;
    }

    &.approve {
      background-color: green;
      :hover {
        background-color: green;
      }
    }

    &.declined {
      background-color: red;
      :hover {
        background-color: red;
      }
    }
  }
`;

export const PrintAreaWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #000;
  margin-bottom: 10px;
  svg {
    cursor: pointer;
  }
`;

export const PrintAreaTitle = styled.h3`
  margin: 0;
`;

export const PrintAreaRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
  svg {
    color: red;
    cursor: pointer;
  }
`;

export const Colorway = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  .src {
    margin-left: 5px;
    background-image: url(https://developer.android.com/reference/android/images/graphics/composite_CLEAR.png?hl=vi);
    display: flex;
    background-size: 50%;
  }
`;

export const AddButton = styled.div`
  background: black;
  margin-bottom: 5px;
  cursor: pointer;
  svg {
    color: white;
  }
`;

export const ShippedTag = styled.div`
  position: absolute;
  background: orange;
  top: 0;
  left: 0;
  color: white;
  padding: 5px;
  font-weight: bold;
`;

export const ModalWrapper = styled.div`
  width: 800px;
  display: flex;
`;

export const ModalBody = styled.div`
  margin-right: 10px;
  border-right: 1px solid #ccc;
  padding-right: 10px;
  flex: 1;
`;

export const ModalBody1 = styled.div`
  flex: 1;
  .MuiFormControl-marginNormal {
    width: 100%;
  }
`;

export const ModalTitle = styled.h1`
  margin: 0;
  border-bottom: 1px solid black;
`;

export const SubmitButton = styled(Button)`
  background-color: black;
  color: white;

  :hover {
    background-color: black;
    color: white;
  }
`;

export const AutocompleteWrapper = styled.div`
  margin-bottom: 20px;
  margin-top: 10px;
`;
